import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';

import { DeviceDetectorService } from 'ngx-device-detector';
import {
  DialogW9formComponent,
  IDataW9Form
} from '../dialog/dialog-w9form.component';
import {
  DialogUploadComponent,
  DialogUploadData
} from '../dialog/dialog-upload.component';

import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';
import { blobToBase64String } from 'blob-util';
import { map, defaultIfEmpty, share, throwIfEmpty, catchError } from 'rxjs/operators';
import {
  AuthenticationService,
  ApplicationApiService,
  ApprovalTaskItemApiService,
  ApplicationPaymentApiService,
  ApplicationEventApiService,
  ContactApiService,
  AnnotationApiService,
  ApplicationTaxRequestApiService
} from '../../data-services/index';

import { AppLoadService, IAdditionalOptions, IAdditionalTaskItem } from '@ebb-v2/ebb-integration';

import {
  IApplication,
  IApplicationInput,
  IApplicationPaymentInput,
  IApprovalTask,
  IApprovalTaskItem,
  IApprovalTaskItemInput,
  IContractor,
  IContact,
  IUser,
  IHelp,
  HelpApiService,
  IOptionSets,
  IOptions,
  IAnnotationInput,
  ContractorApiService,
  UtilityService,
  IApplicationSubmitInput,
  IApplicationTaxRequest,
  SignerInput,
  IDocumentProcessorResponse,
  IRecipient
} from '@ebb-v2/ebb-integration';

import { forkJoin, Observable, Subject } from 'rxjs';

import { DialogtaxrequestformComponent} from '../dialog/dialog-taxrequestform.component';
import { DialogConfirmMessageComponent } from '../dialog/dialog-confirm-message.component';
import * as internal from 'assert';
import { forEach } from 'lodash';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { cloneDeep } from '@apollo/client/utilities';

export interface EbbStepsItem {
  show: () => boolean;
  expanded: () => boolean;
  workNeeded: () => boolean;
  helpTopic: () => void;
 
}

export type EbbSteps = {
  [key in
    | 'sg'
    | 'contractor'
    | 'ldp'
    | 'w9'
    | 'bidinvoice'
    | 'permitreceipt'
    | 'permit'
    | 'house'
    | 'crawlSpace'
    | 'receipt'
  ]: EbbStepsItem
};
@Component({
  selector: 'ebb-portal-preretrofit',
  templateUrl: './preretrofit.component.html'
})
export class PreretrofitComponent implements OnInit, OnChanges {
  @Input('application') application: IApplication;
  @Input('listHelp') listHelp: IHelp[];
  @Input('listAdditionalTaskItem') listAdditionalTaskItem: IAdditionalTaskItem[];
  @Input('listOptionSets') listOptionSets: IOptionSets[];
  @Output() emitEventContractorChange = new EventEmitter<IApplicationInput>();
  @Output() emitEventLdpChange = new EventEmitter<IApplicationInput>();
  @Output() emitPermitInfoChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitDataFormChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitFileChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitBidInvoiceInitEvent = new EventEmitter();
  @Output() emitSubmitApplication = new EventEmitter<IApplicationSubmitInput>();
  @Output() emitWithDrawSGApplication = new EventEmitter();
  @Output() emitIVRChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitReceiptPreretrofitFormChangeEvent = new EventEmitter<IApplicationInput>();
  private onSubject = new Subject<{ key: string; value: any }>();
  public changes = this.onSubject.asObservable().pipe(share());
  public currentUser: IUser;

  // Application Data
  public retrofitContractor: IContractor = null;
  public applicationOwner: IContact = null;

  // Approval Task Data
  public taskLastFocus = '';
  public taskRetrofitContractorTitle = 'Contractor Information';
  public taskRetrofitLdpTitle = 'Design Professional Information';
  public taskRetrofitContractorStatus = 'Pending';
  public taskRetrofitLdpStatus = 'Pending';
  public taskRetrofitbidInvoiceStatus = 'Pending';
  public taskRetrofitPermitReceipteStatus = 'Pending';
  public taskRetrofitContractorSummary = 'Select who will do the retrofit';
  public taskRetrofitLdpSummary = 'Select who will do the retrofit';
  public taskRetrofitContractorHomeowner = false;
  public permitPlanTypeOptions: IOptions[] = {} as IOptions[];
  public additionalPermitOptions: IAdditionalOptions[]  = [];
  public filteredPermitPlanTypeOptions: IOptions[] = [];
  public waitingForContractorEstimate = true;
  public waitingForLdpEstimate = true;
  public taskBuildingPermit: IApprovalTask;
  public waitingForPermitInfo = true;
  public waitingForReceiptInfo = true;
  public addPermitInfo: FormGroup;
  public showAddAnother = true;
  public taskHousePhotos: IApprovalTask;
  public taskCrawlspacePhotos: IApprovalTask;
  public taskReceipts: IApprovalTask;
  public taskW9form: IApprovalTask;
  public w9FormId = '';
  public w9FormPayee = '';
  public w9FormSubmitted = false;
  public w9FormLastFour = '';
  public w9AuthorizationDate: Date;
  public viewApprovalTask = '';
  public progressSaveOptionalPermitDoc = false;
  public isreadonly = false;
  public canShowSubmitDialog = true;
  public readonly stageCode: number = 700000000;
  public textSGMessage: string;
  public textBuildingPermitMessage: string;
  public IsSGApplication = false;
  public isBidInvoiceSelected = false;
  public isPermitReceiptSelected = false;
  public withdrawagreeToTerms = false;
  public submitdrawagreeToTerms = false;
  public onlyEstimateIsRejected = false;
  public isSgWaitList = false;
  public canshowtask = true;
  public taskSG: IApprovalTask = { approvalTaskItems: [] } as IApprovalTask;
  public sgheadingstatus = 'Waitlist';
  public email: string;
  public formAutoSave = false;
  public incomeverificationsubmit = '';
  public sgqualifiedstatusmsg = '';
  public sgnotqualifiedstatusmsg = '';
  public sgincomeverificationconfirmmessage = '';
  public disableSgSubmitButton = false;
  public sgmax4506climtmsg = '';
   public taxYear='';
  public rejected4506cItemsDisplayed = true;
  public sg4506cCount = 0;
  public sg4506cRejectedCount = 0;
  public sg4506cRejected = false;
  public contractorTypeCode: number;
  public attempt = 0;
  public w9message='';
  public estimatemax = 10000;
  public ldpestimatemax = 10000;
  public steps: EbbSteps  = {
    sg: {
      show: () =>
        this.application &&
        this.currentUser &&
        this.isHomeowner() &&
        this.IsSGApplication,
      expanded: () => this.viewApprovalTask === 'sg',
      workNeeded: () =>
        this.application.sGStatus === 700000001 ||
        this.application.sGStatus === 700000002,
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('sg')
    },
   
    contractor: {
      show: () => this.canshowtask,
      expanded: () => this.viewApprovalTask === 'contractor',
      workNeeded: () => {
        const isStatusNotSelectedOrEstimate = 
        this.taskRetrofitContractorStatus.toLowerCase() !== 'selected' &&
        this.taskRetrofitContractorStatus.toLowerCase() !== 'estimate';
      
        const isTypeManualInviteWithInvalidPermissions = 
        this.application.contractorTypeCode === 700000000 &&
        this.application.contractorInvitationCode === 700000000 &&
        this.application.contractorPermissionsCode !== 700000002 &&
        this.application.contractor.contractorManualEntry !== true;
        const permissionnotselected = 
        this.application.contractorTypeCode === 700000000 &&
        this.application.contractorInvitationCode === -1 &&
        this.application.contractorPermissionsCode === -1 &&
        this.application.contractor.contractorManualEntry !== true;
      
        const contractorSelectionNeedsWork = isStatusNotSelectedOrEstimate || isTypeManualInviteWithInvalidPermissions || permissionnotselected;
      

        const needContractorEstimate = this.application.contractorTypeCode === 700000000 && (this.waitingForContractorEstimate)

         
        return contractorSelectionNeedsWork || needContractorEstimate ;
          },
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Construction')
    },
    ldp: {
      show: () => this.canshowtask && this.application.programCycle.engineeredBidMustSubmitDoc,
      expanded: () => this.viewApprovalTask === 'ldp',
      workNeeded: () => {

        if(this.application.programCycle.engineeredBidMustSubmitDoc){
            const ldpSelectionNeedsWork = (this.taskRetrofitLdpStatus.toLowerCase() !== 'selected' &&
              this.taskRetrofitLdpStatus.toLowerCase() !== 'estimate') ||
            (this.application._Ebb_LdpId== null);

            const needldpEstimate = this.waitingForLdpEstimate

         
            return ldpSelectionNeedsWork || needldpEstimate ;
          }
            else{
              return false;
            }
          },
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Design Professional')
    },
    w9: {
      show: () =>
        this.taskW9form &&
        this.taskW9form.stateCode === 0 &&
        !this.isreadonly &&
        this.canshowtask,
      expanded: () => this.viewApprovalTask === 'w9',
      workNeeded: () =>
        (this.taskW9form && this.taskW9form.statusCode === 700000000) ||
        (this.taskW9form && this.taskW9form.statusCode === 700000002),
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('W9form')
    },
    bidinvoice: {
      show: () =>
        this.application &&
        this.currentUser &&
        
        this.IsSGApplication && this.application.sGStatus === 700000004,
      expanded: () => this.viewApprovalTask === 'bidinvoice',
      workNeeded: () => this.checkBidNeedWork(),
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Sgbidinvoice')
    },
    permitreceipt: {
      show: () =>
        this.application &&
        this.currentUser &&
        
        this.IsSGApplication && this.application.sGStatus === 700000004,
      expanded: () => this.viewApprovalTask === 'permitreceipt',
      workNeeded: () =>this.checkPermitReceiptNeedWork(),
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Sgpermitreceipt')
    },
    
    permit: {
      show: () => this.taskBuildingPermit && this.canshowtask,
      expanded: () => this.viewApprovalTask === 'permit',
      workNeeded: () =>
        this.taskBuildingPermit.statusCode === 700000000 ||
        this.taskBuildingPermit.statusCode === 700000002 ||
        !this.application.permitNumber,
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Permit')
    },
    house: {
      show: () => this.taskHousePhotos && this.canshowtask,
      expanded: () => this.viewApprovalTask === 'house',
      workNeeded: () =>
        this.taskHousePhotos.statusCode === 700000000 ||
        this.taskHousePhotos.statusCode === 700000002,
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Photos')
    },
    crawlSpace: {
      show: () => this.taskCrawlspacePhotos && this.canshowtask,
      expanded: () => this.viewApprovalTask === 'crawlSpace',
      workNeeded: () =>
        this.taskCrawlspacePhotos.statusCode === 700000000 ||
        this.taskCrawlspacePhotos.statusCode === 700000002,
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('Payment')
    },
    receipt:{
      show: () => this.taskReceipts && this.canshowtask,
      expanded: () => this.viewApprovalTask === 'receipt',
      workNeeded: () =>
        this.taskReceipts.statusCode === 700000000 ||
        this.taskReceipts.statusCode === 700000002 || this.waitingForReceiptInfo,
      helpTopic: () => this.apiHelp.setCurrentHelpTopicValue('receipt')
    }
  };

  constructor(
    private fb: FormBuilder,
    private readonly deviceService: DeviceDetectorService,
    private readonly dialogW9: MatDialog,
    private readonly dialogConfirmSubmit: MatDialog,
    private readonly dialogUpload: MatDialog,
    private readonly infoSheet: MatBottomSheet,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiApplicationEvent: ApplicationEventApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiApplicationPayment: ApplicationPaymentApiService,
    private readonly apiContractor: ContractorApiService,
    private readonly apiContact: ContactApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiHelp: HelpApiService,
    private readonly appLoadService: AppLoadService,
    private readonly router: Router,
    public readonly utilityService: UtilityService,
    private readonly dialogTaxRequest: MatDialog,
    private readonly apiTaxRequest: ApplicationTaxRequestApiService
  ) {}

  ngOnInit() {
    this.start();
    this.currentUser = this.authenticationService.currentUserValue;
    if(this.application.programCycle.maxBidAmount != null &&  this.application.programCycle.maxBidAmount>0){

      this.estimatemax = this.application.programCycle.maxBidAmount;
    }
    if(this.application.programCycle.maxEngineeredBidAmount != null &&  this.application.programCycle.maxEngineeredBidAmount>0){

      this.ldpestimatemax = this.application.programCycle.maxEngineeredBidAmount;
    }
    this.getOwnerContactInfo();
    this.loadApprovalTaskData();
    this.checkPermitFormData();
    this.checkReceiptFormData();
    this.CheckIsSG();
    this.refreshData(true, null, null, null,null, null, null);

    if (this.application.stateCode === 1) {
      this.isreadonly = true;
    }

    this.addPermitInfo = this.fb.group({
      permitType: []
    });
    
  
    
var listPermit = this.listAdditionalTaskItem.filter(x=>x.stageCode== 700000000 && x.programTypeCode== this.application.programType);
listPermit.forEach(taskItemName=>{

  this.additionalPermitOptions.push({label:taskItemName.name,value:taskItemName.name});
});
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkReceiptFormData();
    //only refresh on changes to application input
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'application': {

            const currentBidAmount =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.contractorBidAmount1 !== undefined
              ? changes.application.previousValue.contractorBidAmount1
              : undefined;
            const currentBidSelected =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.contractorBidAmount1Selected !== undefined
              ? changes.application.previousValue.contractorBidAmount1Selected
              : undefined;
            const currentBidReason =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.contractorBidReason !== undefined
              ? changes.application.previousValue.contractorBidReason
              : undefined;

              const currentLdpBidAmount =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.ldpBidAmount1 !== undefined
              ? changes.application.previousValue.ldpBidAmount1
              : undefined;
            const currentLdpBidSelected =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.ldpBidAmount1Selected !== undefined
              ? changes.application.previousValue.ldpBidAmount1Selected
              : undefined;
            const currentLdpBidReason =
              changes.application.previousValue !== undefined &&
              changes.application.previousValue.ldpBidReason !== undefined
              ? changes.application.previousValue.ldpBidReason
              : undefined;
              this.refreshData(true, currentBidAmount, currentBidSelected, currentBidReason,currentLdpBidAmount, currentLdpBidSelected, currentLdpBidReason);
            this.loadApprovalTaskData();
            this.checkPermitFormData();
            
            this.CheckIsSG();
            
            setTimeout(() => this.checkIfReadyForSubmission(currentBidAmount, currentBidSelected, currentBidReason,currentLdpBidAmount, currentLdpBidSelected, currentLdpBidReason));
          }
        }
      }
    }
  }
  private checkReceiptFormData(): void {
  
    if (this.application.permitCost !== null && this.application.permitCost>0 && this.application.engineeredPlanCost!= null && this.application.engineeredPlanCost>0 ) {
      this.waitingForReceiptInfo = false;
    }
  }
  private checkBidNeedWork():boolean{
    var taskbid = this.taskSG.approvalTaskItems.filter(x =>  x.payloadTypeCode === 700000000 && x.name == 'Invoice for receiving a Bid');
    var status = 0;
    var statusDisplay = 'pending';
    var needsgbi = true;

    if (this.application.sGStatus === 700000004) {
      //if sg bid has not been selected yet then show as pending (sGBidInvoiceNeededHomeowner == true means the HO set the value)
      if (this.application.sGBidInvoiceNeededHomeowner !== true) {
        needsgbi = true;
        this.taskRetrofitbidInvoiceStatus = statusDisplay;
        return needsgbi;
      } else {
        if (this.application.sGBidInvoiceNeeded == true) {

          if (taskbid.length > 0) {
            status = taskbid[0].statusCode;
            switch (status) {
              case 700000000:
                statusDisplay = 'invoice';
                needsgbi = true;
                break;
              case 700000001:
                statusDisplay = 'Approved';
                needsgbi = false;
                break;
              case 700000002:
                statusDisplay = 'rejected';
                needsgbi = true;
                break;
              case 700000003:
                  if(this.application.sGBidInvoiceSubmitted == 1){
                  statusDisplay = 'selected';
                  needsgbi = false;
                }else{
                  statusDisplay = 'pending';
                  needsgbi = true;
                }
                break;
            }
            this.taskRetrofitbidInvoiceStatus = statusDisplay;
            return needsgbi;
          } else {
            statusDisplay = 'invoice';
            needsgbi = true;
            this.taskRetrofitbidInvoiceStatus = statusDisplay;
            return needsgbi;
          }
        } else {
          statusDisplay = 'selected';
          needsgbi = false;
          this.taskRetrofitbidInvoiceStatus = statusDisplay;
          return needsgbi;
        }
      }
    }

    this.taskRetrofitbidInvoiceStatus = statusDisplay;
    return needsgbi;
  }

  private checkPermitReceiptNeedWork():boolean{
    var taskpermitreceipt = this.taskSG.approvalTaskItems.filter(x => x.payloadTypeCode === 700000000 && x.name == 'Permit Receipt');
    var status = 0;
    var statusDisplay = 'pending';
    var needpermitreceipt = true;
    if (this.application.sGStatus === 700000004) {

      //if sg permit has not been selected yet then show as pending (sGBidInvoiceNeededHomeowner == true means the HO set the value)
      if (this.application.sGPermitReceiptSubmittedHomeowner !== true) {
        needpermitreceipt = true;
        this.taskRetrofitPermitReceipteStatus = statusDisplay;
        return needpermitreceipt;
      } else {
        if (this.application.sGHomeownerPaidPermit == true) {
          if (taskpermitreceipt.length > 0) {
            status = taskpermitreceipt[0].statusCode;
            switch (status) {
              case 700000000:
                statusDisplay = 'permitreceipt';
                needpermitreceipt = true;
                break;
              case 700000001:
                statusDisplay = 'Approved';

                needpermitreceipt = false;

                break;
              case 700000002:
                statusDisplay = 'rejected';
                needpermitreceipt = true;
                break;
              case 700000003:
                if (this.application.sGPermitReceiptSubmitted == 1) {
                  statusDisplay = 'selected';
                  needpermitreceipt = false;
                } else {
                  statusDisplay = 'pending';
                  needpermitreceipt = true;
                }

                break;
            }
            this.taskRetrofitPermitReceipteStatus = statusDisplay;
            return needpermitreceipt;
          } else {
            statusDisplay = 'permitreceipt';
            needpermitreceipt = true;
            this.taskRetrofitPermitReceipteStatus = statusDisplay;

            return needpermitreceipt;
          }
        } else {
          statusDisplay = 'selected';
          needpermitreceipt = false;
          this.taskRetrofitPermitReceipteStatus = statusDisplay;

          return needpermitreceipt;
        }
      }
    }

    this.taskRetrofitPermitReceipteStatus = statusDisplay;
    return needpermitreceipt; 
  }

  private refreshData(initialLoad: boolean, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean,currentLdpBidAmount: number, currentLdpBidSelected: boolean, currentLdpBidReason: boolean): void {
    this.getApplicationPaymentId();
    this.loadApprovalTaskData();
    this.setContractorTaskData(false, currentBidAmount, currentBidSelected, currentBidReason);
    this.setLdpTaskData(false, currentLdpBidAmount, currentLdpBidSelected, currentLdpBidReason);
    this.focusApprovalTask(initialLoad);
    const indexPlanTypeOptions = this.listOptionSets.findIndex(
      i => i.name === 'cea_application_cea_permitplancode'
    );
    this.permitPlanTypeOptions = [
      ...this.listOptionSets[indexPlanTypeOptions].options
    ];

    this.filteredPermitPlanTypeOptions = this.permitPlanTypeOptions;
    
  }

  private getApplicationPaymentId(): void {
    if(this.isHomeowner() && this.application !== undefined){
    this.apiApplicationPayment
      .getApplicationPayment(this.application.id)
      .subscribe(
        _data => {
         var data = cloneDeep(_data);
          if (data) {
            this.w9FormId = data.id;
            this.w9FormPayee = data.w9FullName;
            this.w9FormSubmitted = true;
            this.w9FormLastFour = data.w9SsnLast4;
            this.w9AuthorizationDate = data.w9AuthorizationDate;
          } else {
            this.w9FormSubmitted = false;
          }
        },
        err => console.warn(`PreRetrofit.getApplicationPaymentId() - ${err}`)
      );
  }}

  /**********************************************
   * Owner
   */

  private getOwnerContactInfo(): void {
    this.getContact(this.application._Ebb_OwnerId);
  }

  private getContact(currentId: string): void {
    this.apiContact.getContact(currentId).subscribe(
      data => {
        this.applicationOwner = data;
        this.email = this.applicationOwner.emailAddress1;
      },
      error => console.warn(`ERROR: UserAccount.getContact() - ${error}`)
    );
  }

  /**********************************************
   * Contractor
   */
  private setContractorTaskData(refreshCache: boolean, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean): void {
    const taskitems = this.taskBuildingPermit.approvalTaskItems;
    let contractorDataAndStatusUpdatecheck = false;
    const bids = taskitems.filter(
      x => x.name === 'Estimate' && x.payloadTypeCode === 700000001
    );

    if (bids.filter(x => x.statusCode === 700000002).length > 0) {
      this.taskRetrofitContractorStatus = 'rejected';
    } else {
      if (
        this.application.contractorTypeCode !== null &&
        parseInt(this.application.contractorTypeCode.toString(), 10) ===
          700000000
      ) {
        if (
          this.application._Ebb_ContractorId &&
          this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId
        ) {
          this.contractorDataAndStatusUpdate(this.application, refreshCache, currentBidAmount, currentBidSelected, currentBidReason);
          contractorDataAndStatusUpdatecheck = true;
        }
      } else {
        this.taskRetrofitContractorStatus = 'Pending';
      }
    }

    if (
      this.application.contractorTypeCode > 0 &&
      this.taskRetrofitContractorStatus !== 'rejected'
    ) {
      // 700000000: Contractor; 700000001: Owner
      if (
        parseInt(this.application.contractorTypeCode.toString(), 10) ===
        700000000
      ) {
        if (
          this.application._Ebb_ContractorId &&
          this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId
        ) {
          if (!contractorDataAndStatusUpdatecheck) {
            this.contractorDataAndStatusUpdate(this.application, refreshCache, currentBidAmount, currentBidSelected, currentBidReason);
          }
        } else {
          this.taskRetrofitContractorStatus = 'Pending';
          if (this.contractorTypeCode === 700000000) {
            this.taskRetrofitContractorSummary = 'Select contractor';
          }
        }
      } else {
        this.taskRetrofitContractorStatus = 'Selected';
        this.taskRetrofitContractorSummary = 'Homeowner';
      }
    } else {
      if (this.taskRetrofitContractorHomeowner) {
        this.taskRetrofitContractorSummary = 'Homeowner';
        this.taskRetrofitContractorHomeowner = false;
        this.taskRetrofitContractorStatus = 'Selected';
      } else {
        this.taskRetrofitContractorSummary = 'Select who will do the retrofit';
      }
    }
  }


   /**********************************************
   * Design Professional
   */
   private setLdpTaskData(refreshCache: boolean, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean): void {
    const taskitems = this.taskBuildingPermit.approvalTaskItems;
    let ldpDataAndStatusUpdatecheck = false;
    const bids = taskitems.filter(
      x => x.name === 'Design Professional Estimate' && x.payloadTypeCode === 700000001
    );

    if (bids.filter(x => x.statusCode === 700000002).length > 0) {
      this.taskRetrofitLdpStatus = 'rejected';
    } else {
    
        if (
          this.application._Ebb_LdpId 
         
        ) {
          this.setLdpNameAndStatus(this.application, currentBidAmount, currentBidSelected, currentBidReason);
        
          ldpDataAndStatusUpdatecheck = true;
        }
      
    }

    if (
           this.taskRetrofitLdpStatus !== 'rejected'
    ) {
   
        if (
          this.application._Ebb_LdpId
        ) {
          if (!ldpDataAndStatusUpdatecheck) {
            this.setLdpNameAndStatus(this.application, currentBidAmount, currentBidSelected, currentBidReason);
        
          }
        } else {
          this.taskRetrofitLdpStatus = 'Pending';
          if (this.application._Ebb_LdpId === null) {
            this.taskRetrofitLdpSummary = 'Select who will do the retrofit';
          }
        }
      
    }
  }
  private contractorDataAndStatusUpdate(
    application: IApplication,
    refreshCache: boolean,
    currentBidAmount: number,
    currentBidSelected: boolean,
    currentBidReason: boolean
  ): void {
    if (refreshCache) {
      this.apiContractor
        .getContractor(application._Ebb_ContractorId, refreshCache)
        .subscribe(
          data => {
            if (data) {
              application.contractor = cloneDeep(data);;
              this.setContractorNameAndStatus(application, currentBidAmount, currentBidSelected, currentBidReason);
            }
          },
          error => console.warn(error)
        );
    } else {
      this.setContractorNameAndStatus(application, currentBidAmount, currentBidSelected, currentBidReason);
    }
  }

  private setContractorNameAndStatus(application: IApplication, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean): void {
    //name field
    if (
      !this.taskRetrofitContractorHomeowner &&
      application &&
      application.contractor &&
      application.contractor.fullName
    ) {
      this.taskRetrofitContractorSummary = `${application.contractor.fullName}`;
      if (application.contractor.businessName) {
        this.taskRetrofitContractorSummary += ` (${
          application.contractor.businessName
        })`;
      }
    } else {
      if (!this.taskRetrofitContractorHomeowner) {
        this.taskRetrofitContractorSummary = '';
      }
    }

    this.taskRetrofitContractorHomeowner = false;

    if (this.taskRetrofitContractorHomeowner) {
      this.taskRetrofitContractorStatus = 'Selected';
    } else {
      //if bid is not needed or bid requirements are met
      if (this.utilityService.bidRequirementsMet(this.application, currentBidAmount, currentBidSelected, currentBidReason,this.estimatemax)) {
        //waiting for permission
        if (
          parseInt(this.application.contractorInvitationCode.toString(), 10) ===
            700000000 &&
          parseInt(
            this.application.contractorPermissionsCode.toString(),
            10
          ) === 700000000 &&
          this.application.contractor.contractorManualEntry !== true
        ) {
          this.taskRetrofitContractorStatus = 'Permission';
        }
        //waiting for user to select permission yes/no
        else if (
          parseInt(
            this.application.contractorPermissionsCode.toString(),
            10
          ) === 700000000 &&
          this.application.contractor.contractorManualEntry !== true
        ) {
          this.taskRetrofitContractorStatus = 'Permission';
        }
        //waiting for user to select permission yes/no  
        else if (
           this.application.contractorInvitationCode === -1 &&
            this.application.contractorPermissionsCode === -1 &&
          this.application.contractor.contractorManualEntry !== true
        ) {
          this.taskRetrofitContractorStatus = 'Permission';
        }
        else if (this.application.contractorInvitationCode ===700000003 && this.application.contractor.contractorManualEntry !== true) {
          
          this.taskRetrofitContractorStatus = 'rejected';
        }
        //Contractor selection complete
        else {
          this.taskRetrofitContractorStatus = 'Selected';
        }
        this.waitingForContractorEstimate = false;
      } else {
        //estimate is needed
        if (parseInt(this.application.contractorInvitationCode.toString(), 10) === 700000000 &&
          parseInt(this.application.contractorPermissionsCode.toString(), 10) === 700000000 &&
          this.application.contractor.contractorManualEntry !== true) {
          this.taskRetrofitContractorStatus = 'Permission';
        } else {
          this.taskRetrofitContractorStatus = 'Estimate';
        }
        this.waitingForContractorEstimate = true;
      }
    }
  }
  private setLdpNameAndStatus(application: IApplication, currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean): void {
    //name field
    if (
      application &&
      application._Ebb_LdpId &&
      application._Ebb_LdpId_Formatted
    ) {
      this.taskRetrofitLdpSummary = `${application._Ebb_LdpId_Formatted}`;
      this.taskRetrofitLdpStatus = 'Selected';
    } else {
      
        this.taskRetrofitLdpSummary = '';
      
    }

   

    
      //if bid is not needed or bid requirements are met
      if (this.utilityService.bidLdpRequirementsMet(this.application, currentBidAmount, currentBidSelected, currentBidReason,this.ldpestimatemax)) {
        //waiting for permission
        
        this.taskRetrofitLdpStatus = 'Selected';
        this.waitingForLdpEstimate = false;
      } else {
       
          this.taskRetrofitLdpStatus = 'Estimate';
        
        this.waitingForLdpEstimate = true;
      }
    
  }
  /**********************************************
   * Form Data
   */
  private checkPermitFormData(): void {
    if (this.application.permitNumber &&
      this.loadTaskStatusValue('permit', this.getPermitStatus()) !== 'Waiting for information') {
      this.waitingForPermitInfo = false;
    }
  }

  public checkPermitStatus(status: string): boolean {
    let result = false;

    if (status === 'accept') {
      this.checkPermitFormData();

      const approved =
        this.taskBuildingPermit.approvalTaskItems.filter(
          x => x.statusCode === 700000001 && x.name !== 'Estimate'
        ).length > 0
          ? true
          : false;

      const pending =
        this.taskBuildingPermit.approvalTaskItems.filter(
          x => x.statusCode === 700000000 && x.name !== 'Estimate'
        ).length > 0
          ? true
          : false;

      const updated =
        this.taskBuildingPermit.approvalTaskItems.filter(
          x => x.statusCode === 700000003 && x.name !== 'Estimate'
        ).length > 0
          ? true
          : false;

      const rejected =
        this.taskBuildingPermit.approvalTaskItems.filter(
          x => x.statusCode === 700000002 && x.name !== 'Estimate'
        ).length > 0
          ? true
          : false;

      if (approved && !pending && !rejected && !updated) {
        return (result = true);
      }

      if ((pending || updated) && !this.waitingForPermitInfo) {
        result = true;
      }
    }

    if (status === 'reject') {
      result =
        this.taskBuildingPermit.approvalTaskItems.filter(
          x => x.statusCode === 700000002 && x.name !== 'Estimate'
        ).length > 0
          ? true
          : false;
    }

    return result;
  }

  public getPermitStatus(): number {
    let result = 700000001;

    const approved =
      this.taskBuildingPermit.approvalTaskItems.filter(
        x => x.statusCode === 700000001  &&  x.payloadTypeCode === 700000000
      ).length > 0
        ? true
        : false;

    const pending =
      this.taskBuildingPermit.approvalTaskItems.filter(
        x => x.statusCode === 700000000  &&  x.payloadTypeCode === 700000000
      ).length > 0
        ? true
        : false;

    const updated =
      this.taskBuildingPermit.approvalTaskItems.filter(
        x => x.statusCode === 700000003  &&  x.payloadTypeCode === 700000000
      ).length > 0
        ? true
        : false;

    const rejected =
      this.taskBuildingPermit.approvalTaskItems.filter(
        x => x.statusCode === 700000002  &&  x.payloadTypeCode === 700000000
      ).length > 0
        ? true
        : false;

    if (approved && !pending && !rejected && !updated) {
      return (result = 700000001);
    }

    if (rejected) {
      return (result = 700000002);
    }

    if (pending) {
      return (result = 700000000);
    }

    if (updated) {
      return (result = 700000003);
    }

    return result;
  }

  /**********************************************
   * W-9 Data
   */

  public enableW9Form(): boolean {
    //hopefully simplifying, if taskW9Form exists and not Approved or Updated than show
    const isw9FormTask =
      this.taskW9form &&
      this.taskW9form.approvalTaskItems[0].statusCode !== 700000001 &&
      this.taskW9form.approvalTaskItems[0].statusCode !== 700000003;

    //not sure if the following logic still holds
    //early submission means you can exit PreliminaryReview stage for PreliminaryReview Reject stage
    /*
    const status = ((this.application.sGStatus === 700000004 && this.taskW9form.approvalTaskItems[0].statusCode !== 700000001 && this.taskW9form.approvalTaskItems[0].statusCode !== 700000003) ||
    (!this.application.eventPreliminaryReview ||
    (this.application.eventPreliminaryReview && this.taskW9form.approvalTaskItems[0].statusCode === 700000002)));
    */
    return isw9FormTask && this.isHomeowner();
  }

  public disableBuildingPermitForm(): boolean {
    if (this.IsSGApplication) {
      if (this.application.sGBuildingPermitProcessing != null) {
        return true;
      }

      const isw9Complete =
        this.taskW9form &&
        this.taskW9form.approvalTaskItems[0].statusCode === 700000001;
      const isPermitComplete =
        this.taskBuildingPermit &&
        this.taskBuildingPermit.statusCode === 700000001;

      return isw9Complete && isPermitComplete;
    }

    return false;
  }

  public onClickSubmitW9data(): void {
    const dataDialog: IDataW9Form = {} as IDataW9Form;
    dataDialog.w9FullName = this.application._Ebb_OwnerId_Formatted;
    dataDialog.w9AddressStreet = this.applicationOwner.address1_Line1;
    if(this.applicationOwner.address1_Line2 != null && this.applicationOwner.address1_Line2.length >0){
      dataDialog.w9AddressStreet += " "+ this.applicationOwner.address1_Line2;
    }
    dataDialog.w9AddressCity = this.applicationOwner.address1_City;
    dataDialog.w9AddressState = this.applicationOwner.address1_StateOrProvince;
    this.applicationOwner.address1_PostalCode &&
    this.applicationOwner.address1_PostalCode.indexOf('-') > 0
      ? (dataDialog.w9AddressZip = this.applicationOwner.address1_PostalCode.split(
          '-'
        )[0])
      : (dataDialog.w9AddressZip = this.applicationOwner.address1_PostalCode);
    dataDialog.w9SsnLast4 = this.w9FormLastFour;

    const dialogRef = this.dialogW9.open(DialogW9formComponent, {
      width: '400px',
      data: dataDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const applicationPaymentInput: IApplicationPaymentInput = {} as IApplicationPaymentInput;
        applicationPaymentInput._Ebb_ApplicationId = this.application.id;
        applicationPaymentInput.w9FullName = dataDialog.w9FullName;
        applicationPaymentInput.w9SsnLast4 = dataDialog.w9Ssn;
        applicationPaymentInput.w9AddressStreet = dataDialog.w9AddressStreet;
        applicationPaymentInput.w9AddressCity = dataDialog.w9AddressCity;
        applicationPaymentInput.w9AddressState = dataDialog.w9AddressState;
        applicationPaymentInput.w9AddressZip = dataDialog.w9AddressZip;
        applicationPaymentInput.w9AuthorizationDate =
          dataDialog.w9AuthorizedDate;
        if (applicationPaymentInput.w9SsnLast4.startsWith('00000')) {
          delete applicationPaymentInput['w9SsnLast4'];
        }
        this.w9FormPayee = dataDialog.w9FullName;
        this.w9AuthorizationDate = dataDialog.w9AuthorizedDate;
        this.apiApplicationPayment
          .updateApplicationPayment(applicationPaymentInput, this.w9FormId)
          .subscribe(
            data => {
              this.w9FormId = cloneDeep(data);;
              this.w9FormPayee = dataDialog.w9FullName;
              this.w9FormLastFour = dataDialog.w9Ssn.slice(
                dataDialog.w9Ssn.length - 4
              );
              this.w9FormSubmitted = true;

              const applicationInput: IApplicationInput = {} as IApplicationInput;
              applicationInput.w9DataSubmitted = true;
              this.apiApplication
                .updateApplication(applicationInput, this.application.id)
                .subscribe(
                  () => {
                    this.updateDataTaskItem(this.taskW9form, this.w9FormId);
                  },
                  error =>
                    console.warn(`Error: onClickSubmitW9Data() - ${error}`)
                );
            },
            err => console.warn(`onClickSubmitW9Data() - ${err}`)
          );
      }
    });
  }

  private updateDataTaskItem(task: IApprovalTask, payloadName: string): void {
    const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItem = task.approvalTaskItems[0];
    approvalTaskItem.id = taskItem.id;
    approvalTaskItem.payloadName = payloadName;
    approvalTaskItem.submitDate = nowDate;
    if (taskItem.statusCode !== 700000003) {
      approvalTaskItem.statusCode = 700000003;
    }

    this.apiApprovalTaskItem
      .saveItem(approvalTaskItem, this.application.id, null)
      .subscribe(
        data => {
          if (task.statusCode !== 700000003) {
            task.statusCode = 700000003;
          }
          this.application.w9DataSubmitted = true;
          this.w9FormSubmitted = true;
          this.onEmitDataFormUpdate(task);
        },
        err => console.warn(`ApprovalDataForm.updateTaskItem() - ${err}`)
      );
  }

  /**********************************************
   * Submission
   */

  private checkIfReadyForSubmission(currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean,currentLdpBidAmount: number, currentLdpBidSelected: boolean, currentLdpBidReason: boolean): void {
    if (this.evalIfReadyForSubmission(currentBidAmount, currentBidSelected, currentBidReason,currentLdpBidAmount,currentLdpBidSelected,currentLdpBidReason)) {
      this.onEmitSubmitApplication(true);
    } else {
      this.onEmitSubmitApplication(false);
    }
  }

  private evalIfReadyForSubmission(currentBidAmount: number, currentBidSelected: boolean, currentBidReason: boolean,currentLdpBidAmount: number, currentLdpBidSelected: boolean, currentLdpBidReason: boolean): Boolean {
    let itemsCount = 0,
      itemsApprovedOrSubmitted = 0;
    let formsCompleted = false;
    var ispermitcompleted = this.isPermitFormComplete();
    var isReceiptFormComplete = this.isReceiptFormComplete();
    // check if data for forms have been submitted
    formsCompleted = this.application.permitIssuer !== null && this.application.permitIssuer.length > 0 && ispermitcompleted?true:false;
      
    // If Contractor is selected (i.e. not DIY) and bid requirements have not been met
    if (
      this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId &&
      !this.utilityService.bidRequirementsMet(this.application, currentBidAmount, currentBidSelected, currentBidReason,this.estimatemax)
    ) {
      return false;
    }
    const isStandardContractor = this.application.contractorTypeCode === 700000000;
    const isPermissionNotSelected =
      this.application.contractorInvitationCode === -1 &&
      this.application.contractorPermissionsCode === -1 &&
      this.application.contractor.contractorManualEntry !== true;
    
    const isContractorRejected =
      this.application.contractorInvitationCode === 700000003 &&
      this.application.contractor.contractorManualEntry !== true;
    
    if (isStandardContractor && (isPermissionNotSelected || isContractorRejected)) {
      return false;
    }
    if(this.application.programCycle.engineeredBidMustSubmitDoc===true){
      if(this.application._Ebb_LdpId === null){
        return false;
        }

        if(!this.utilityService.bidLdpRequirementsMet(this.application, currentLdpBidAmount, currentLdpBidSelected, currentLdpBidReason,this.ldpestimatemax)){
          return false;
          }
    }

    if(this.application.sGStatus === 700000001 || //waitlist
      this.application.sGStatus === 700000002     //Self-Eligible
    ) {
        return false;
    }

    // If Contractor is selected (i.e. not DIY) and permission selection have not been met
    if (
      this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId &&
      this.application.contractorPermissionsCode === 700000000
    ) {
      return false;
    }
    if (
      this.application.sGStatus === 700000004 &&
      this.application.sGBidInvoiceNeededHomeowner !== true 
    ) {
      return false;
    }
    if (
      this.application.sGStatus === 700000004 &&
      this.application.sGPermitReceiptSubmittedHomeowner !== true 
    ) {
      return false;
    }
    // If Contractor bid invoice is not needed or submitted
    var isbidinvoicerejectedornotsubmitted =
      this.application.sGBidInvoiceSubmitted === undefined ||
      this.application.sGBidInvoiceSubmitted === null ||
      this.application.sGBidInvoiceSubmitted === 0 ||
      this.application.sGBidInvoiceSubmitted === 2;

    if (
      this.application.sGStatus === 700000004 &&
      this.application.sGBidInvoiceNeeded === true &&
      isbidinvoicerejectedornotsubmitted
    ) {
      return false;
    }
    var ispermitrejectedornotsubmitted =
      this.application.sGPermitReceiptSubmitted === undefined ||
      this.application.sGPermitReceiptSubmitted === null ||
      this.application.sGPermitReceiptSubmitted === 0 ||
      this.application.sGPermitReceiptSubmitted === 2;
    if (
      this.application.sGStatus === 700000004 &&
      this.application.sGHomeownerPaidPermit === true &&
      ispermitrejectedornotsubmitted
    ) {
      return false;
    }
    if(!isReceiptFormComplete){
      return false;
    }
    // If app is in PreRetrofit stage and app has been submitted for preliminary review and there are no rejections,
    if (
      this.application.stageCode === this.stageCode &&
      this.application.eventPreliminaryReview &&
      this.application.submissionRejection === 700000000
    ) {
      return false;
    }

    if (
      this.isContractor() &&
      this.application.contractorPermissionsCode === 700000000
    ) {
      return false;
    }

    // 700000000: Contractor; 700000001: Owner
    // The intent of the conditions below:
    // - Confirm that Contractor type is 'Contractor' or 'Homeowner'
    // - If Contractor type is 'Contractor' (instead of 'Homeowner'), then all of the following conditions must be true
    // - Contractor ID has been provided
    // - Contractor ID is not the same as Homeowner ID
    // - A bid has been submitted
    // - If the bid amount is > $10k, a second bid has been submitted
    if (
      (this.application.contractorTypeCode === 700000000 &&
        (this.application._Ebb_ContractorId &&
          this.application._Ebb_ContractorId.length > 0) &&
        this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId &&
        this.isNecessaryBidSubmitted(
          this.application.contractorBidAmount1,
          this.application.contractorBidAmount2,
          this.application.contractorBidReason,
          this.application.contractorBidAmount1Selected
        )) ||
      this.application.contractorTypeCode === 700000001
    ) {
      itemsCount++;
      itemsApprovedOrSubmitted++;
    } else {
      itemsCount++;
    }

    this.application.approvalTasks.forEach(task => {
      if (task.stageCode === this.stageCode) {
        task.approvalTaskItems.forEach(item => {
          if (item.statusCode === 700000001 || item.statusCode === 700000003) {
            itemsCount++;
            itemsApprovedOrSubmitted++;
          } else {
            itemsCount++;
          }
        });
      }
    });



    if (
      itemsCount === itemsApprovedOrSubmitted &&
      formsCompleted &&
      this.application.itemsRejectedRollup <= 0
    ) {
      return true; 
    } else {
      return false;
    }
  }

  private isPermitFormComplete(): Boolean {
    
    if(!(this.application.permitIssuer &&
        this.application.permitIssuedDate  &&
        this.application.permitPlanCode &&
        this.application.permitNumber)) {
          return false;
    }

    if(this.IsSGApplication) {
      if((this.application.sGHomeownerPaidPermit === true && this.application.permitCost) ||
        this.application.sGHomeownerPaidPermit === false) {
          return true;
        }
      else {
        return false;
      }
    }
    else {
      return true;
    }
  }
  private isReceiptFormComplete(): boolean {
    // If the program type is not 700000004, consider the form complete
    if (this.application.programType !== 700000004) {
        return true;
    }

    // Check if engineeredPlanCost or permitCost are null or zero
    if (
        this.application.engineeredPlanCost == null ||
        this.application.permitCost == null ||
        this.application.engineeredPlanCost === 0 ||
        this.application.permitCost === 0
    ) {
        return false;
    }

    // If all checks pass, the form is complete
    return true;
}


  /*
  NOTE: A new application is created with cea_submission_rejection === 700000000.
  Once an application is submitted, any rejections will set cea_submission_rejection === 700000001.
  Thus, when eventPreliminaryReview is FALSE then submissionRejection must be 700000000.
  Then, when eventPreliminaryReivew is TRUE then submissionRejection must be equal to 700000001.
  The following articulates the logic below.
  */
  public canAddPermitInfo(): Boolean {
    const isUserHiredContractorAllowedEdit = this.currentUser.id === this.application._Ebb_OwnerId ||
      (this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId 
      && this.application.contractorPermissionsCode === 700000001);
    return (
      this.showAddAnother && isUserHiredContractorAllowedEdit &&
      ((this.application.eventPreliminaryReview === false &&
        this.application.submissionRejection === 700000000 || this.application.submissionRejection === null) ||
        (this.application.eventPreliminaryReview === true &&
          this.application.submissionRejection === 700000001 ))
    );
  }

  /**********************************************
   * Emit
   */

  public onEmitContractorUpdate(input: IApplicationInput) {
    this.emitEventContractorChange.emit(input);
    this.taskRetrofitContractorSummary =
      input.contractorTypeCode === 700000001
        ? 'Homeowner'
        : this.taskRetrofitContractorSummary;
    this.contractorTypeCode = input.contractorTypeCode;
    this.taskRetrofitContractorHomeowner =
      input.contractorTypeCode === 700000001
        ? true
        : this.taskRetrofitContractorHomeowner;
    this.updateBidAmountsOnApp(input);
  } 
  
  public onEmitLdpUpdate(input: IApplicationInput) {
    this.emitEventContractorChange.emit(input);
  
    this.updateEnggBidAmountsOnApp(input);
  }

  public onEmitPermitUpdate(input: IApplicationInput) {
    if (
      (this.taskW9form && this.taskW9form.statusCode === 700000000) ||
      (this.taskW9form && this.taskW9form.statusCode === 700000002)
    ) {
      if(this.application.sGStatus ===700000004){
      this.completeW9Message(this.getHelpText('sgcompletew9msg'));}
    }
    this.emitPermitInfoChangeEvent.emit(input);
  }
  public onEmitReceiptPreretrofitFormUpdate(input: IApplicationInput) {
   
    this.emitReceiptPreretrofitFormChangeEvent.emit(input);
  }
  public onEmitContractorFileUploadEvent(task: IApprovalTask) {
    this.taskBuildingPermit = task;
    this.emitFileChangeEvent.emit(task);
    this.setContractorTaskData(true, null, null, null);
  }
  public onEmitLdpFileUploadEvent(task: IApprovalTask) {
    this.taskBuildingPermit = task;
    this.emitFileChangeEvent.emit(task);
    this.setLdpTaskData(true, null, null, null);
  }

  public onEmitFileUploadEvent(task: IApprovalTask) {
    this.emitFileChangeEvent.emit(task);
  }

  public onEmitBidInvoiceFileUploadEvent(task: IApprovalTask) {
    this.isBidInvoiceSelected = true;
    this.emitFileChangeEvent.emit(task);
  }

  public onEmitPermitReceiptInitEvent(selected: boolean) {
    this.isPermitReceiptSelected = selected;
  }
  public onEmitPermitReceiptFileUploadEvent(task: IApprovalTask) {
    this.isPermitReceiptSelected = true;
    this.emitFileChangeEvent.emit(task);
  }

  public onEmitBidInvoiceInitEvent(selected: boolean) {
    this.isBidInvoiceSelected = selected;
  }


  public onEmitDataFormUpdate(task: IApprovalTask) {
    this.emitDataFormChangeEvent.emit(task);
  }
 
  public onEmitSubmitApplication(submit: boolean) {
    this.emitSubmitApplication.emit({
      stageCode: this.stageCode,
      submit: submit
    } as IApplicationSubmitInput);
  }
  

  public onEmitBidInvoiceApplicationChangeEvent(appInput: IApplicationInput) {
    this.apiApplication
      .updateApplication(appInput, this.application.id)
      .subscribe(
        res =>{
          this.onEmitBidInvoiceFileUploadEvent(null);
        },
        err =>
          console.error(
            'ERROR: updating application bid invoice'
          )
      );
  }
  public onEmitPermitReceiptApplicationChangeEvent(appInput: IApplicationInput) {
    this.apiApplication
      .updateApplication(appInput, this.application.id)
      .subscribe(
        res =>{
          this.onEmitPermitReceiptFileUploadEvent(null);
        },
        err =>
          console.error(
            'ERROR: updating application bid invoice'
          )
      );
  }
  public onEmitOpenDocuUrl(change: boolean) {
    this.start();
  }

  public onEmitAnyRejected4506cItemsDisplayed(rejected4506cItemsDisplayed: boolean) {
    this.rejected4506cItemsDisplayed = rejected4506cItemsDisplayed;
  }

  public onEmitResubmitTaxRequestData(item: IApprovalTaskItem) {
    
    this.taxYear = item.taxYear;
    this.attempt = item.attempt;
  this.onClickReSubmitDocumentsTaxRequestData(item);
  }
  public onEmitsubmitTaxRequestData(item: IApprovalTaskItem) {
    this.taxYear = item.taxYear;
    this.onClickSubmitTaxRequestData(false,this.application.sg4506CRequestType === 700000001? true:false,item.id);
  }

  public onIVRChange(task: IApprovalTask) {
    this.emitIVRChangeEvent.emit(task);
  }

  /**********************************************
   * Expansion Panel
   */
  private loadApprovalTaskData(): void {
    const approvalTaskList = this.application.approvalTasks.filter(
      (task: IApprovalTask) => (task.stageCode === 700000000) !== false
    );

    // 700000000: Permit; 700000001: House;
    // 700000002: CrawlSpace; 700000004: Payment;
    // 700000005: Application Payment; 700000006: Supplemental Grant;
    approvalTaskList.forEach(task => {
      switch (parseInt(task.uiTabName, 10)) {
        case 700000000:
          this.taskBuildingPermit = task as IApprovalTask;
          break;
        case 700000001:
          this.taskHousePhotos = task as IApprovalTask;
          break;
        case 700000002:
          this.taskCrawlspacePhotos = task as IApprovalTask;
          break;
        case 700000004:
            this.taskReceipts = task as IApprovalTask;
            break;
        case 700000005:
          this.taskW9form = task as IApprovalTask;
          break;
        case 700000006:
          this.taskSG = task as IApprovalTask;
          break;
      }
    });
  }

  private focusApprovalTask(initialLoad: boolean): void {
    const isMobile = this.deviceService.isMobile();
    if (isMobile && initialLoad) {
      this.setApprovalTask('');
    } else {
      //find first step that needs work
      const targetEnabled = Object.values(this.steps).findIndex(
        x => x.show() === true && x.workNeeded()
      );
      const keyName = Object.keys(this.steps)[targetEnabled];
      this.setApprovalTask(keyName as
        | 'sg'
        | 'contractor'
        | 'ldp'
        | 'w9'
        | 'bidinvoice'
        | 'permitreceipt'
        | 'permit'
        | 'house'
        | 'crawlSpace' 
        | 'receipt'
       );
    }
  }

  private isNecessaryBidSubmitted(
    bidAmt1: number,
    bidAmt2: number,
    reason: boolean,
    bid1Selected: boolean
  ): boolean {
    const bidAmt1Number: number =
      bidAmt1 !== null && bidAmt1 !== undefined ? bidAmt1 : 0;
    const bidAmt2Number: number =
      bidAmt2 !== null && bidAmt2 !== undefined ? bidAmt2 : 0;

    if (
      this.application.programCycle.bidMustSubmitDoc !== true ||
      this.application.stageCode !== this.stageCode
    ) {
      // if not required - pass
      return true;
    } else if (this.application.programCycle.multipleBidsRequired !== true) {
      // need one bid, with positive dollar amount
      return bidAmt1Number > 0;
    } else {
      // else user select bid under 10k or give reason
      return (
        (bidAmt1Number > 0 && bidAmt1Number <= this.estimatemax) ||
        (bidAmt1Number > this.estimatemax &&
          reason === false &&
          bidAmt2Number > 0 &&
          bidAmt1Number <= bidAmt2Number &&
          bid1Selected === true) ||
        (bidAmt2Number > this.estimatemax &&
          reason === false &&
          bidAmt1Number > 0 &&
          bidAmt2Number <= bidAmt1Number &&
          bid1Selected === false) ||
        (bidAmt1Number > this.estimatemax && reason === true && bidAmt2Number > 0)
      );
    }
  }
  public isSgQualify() : boolean  {
    return this.application.sGStatus === 700000004 && !this.isContractor();
  }
 
  public loadTaskStatusIconHtml(
    type: 'sg' | 'contractor' |'ldp'| 'w9' |'bidinvoice'| 'permitreceipt' | 'permit' | 'house' | 'crawlSpace'| 'receipt',
    status: number
  ): string {
    const targetKey = Object.keys(this.steps).findIndex(x => x === type);
    const targetEnabled = Object.values(this.steps)
      .slice(0, targetKey)
      .filter(x => x.show() === true);
    
    let iconName = 'fa-solid fa-square-' + (targetEnabled.length + 1)+" fa-sm";
    var checkbox ='fa-solid fa-square-check fa-sm';
    var warning ='fa-solid fa-triangle-exclamation fa-sm';
    if(type === 'bidinvoice'){

      if(this.application.sGBidInvoiceNeededHomeowner === null){
        
        return "<i class='"+iconName+"'/>";
      }
if(this.application.sGBidInvoiceNeededHomeowner === true){

  if(this.application.sGHomeownerPaidPermit== false){
    return "<i class='"+checkbox+"'/>";
  }else{

    var taskbid = this.taskSG.approvalTaskItems.filter(x=>x.name =='Invoice for receiving a Bid');
    if(taskbid.length>0){
    status = taskbid[0].statusCode;   }else{
      status =700000001
    }
  }

}    }
if(type === 'permitreceipt'){
  if(this.application.sGPermitReceiptSubmittedHomeowner == null){
    return "<i class='"+iconName+"'/>";
  }
  if(this.application.sGPermitReceiptSubmittedHomeowner == true){
    
  
    if(this.application.sGHomeownerPaidPermit== false){
      return "<i class='"+checkbox+"'/>";
    }else{
      var taskpermit = this.taskSG.approvalTaskItems.filter(x=>x.name =='Permit Receipt');
      if(taskpermit.length>0){
        status = taskpermit[0].statusCode;   }else{
          status =700000001
        }
      
     
    }
  
  }    
}
    switch (status) {
      case 700000001:
        iconName = checkbox;
     
        break;
      case 700000002:
        iconName = warning;

        break;
      case 700000003:
        if (type === 'permit' && !this.application.permitNumber) {
          //section needs work - just show number: iconName
        } else {
          iconName = checkbox;
        }
        if(type ==='receipt'&& this.waitingForReceiptInfo){

        }else{
          iconName = checkbox;
        }
        break;
    }
    return "<i class='"+iconName+"'/>";
  }

  

  public loadTaskStatusValue(
    type: 'sg' | 'bidinvoice'| 'w9' |'permitreceipt' |'contractor'  |'ldp'| 'permit' | 'house' | 'crawlSpace'| 'receipt',
    status: number
  ): string {
    let statusDisplay = '';
   
if(type === 'bidinvoice' ){
if(this.application.sGBidInvoiceNeeded == true){
  var taskbid = this.taskSG.approvalTaskItems.filter(x=>x.name =='Invoice for receiving a Bid');
  status = taskbid[0].statusCode;}
  else if (this.application.sGBidInvoiceNeeded == false && this.application.sGBidInvoiceNeededHomeowner == true){
    return 'Completed';
  } 
}
if(type === 'permitreceipt' ){
  if(this.application.sGHomeownerPaidPermit == true){
    var taskpermit = this.taskSG.approvalTaskItems.filter(x=>x.name =='Permit Receipt');
    status = taskpermit[0].statusCode;}
    else if (this.application.sGHomeownerPaidPermit == false && this.application.sGPermitReceiptSubmittedHomeowner == true){
      return 'Completed';
    } 
    console.warn(type+status);
  }
  


    switch (status) {
      case 700000000:
        statusDisplay = 'Waiting for information';
        break;
      case 700000001:
        statusDisplay = 'Approved';
        break;
      case 700000002:
        statusDisplay = 'Action required';
        break;
      case 700000003:
        if (this.application.eventPreliminaryReview) {
          statusDisplay = 'Under Review (In Process)';
        } else {
          statusDisplay = 'Updated';
        }
        if (type === 'permit') {
          !this.application.permitNumber
          ? (statusDisplay = 'Waiting for information')
          : (this.waitingForPermitInfo = false);
          const rejectedItems = this.taskBuildingPermit.approvalTaskItems.filter(item => item.submissionReject === 1);
          if (rejectedItems.length === 1 && rejectedItems[0].name === 'Estimate' && rejectedItems[0].payloadTypeCode !== 700000000) {
            this.onlyEstimateIsRejected = true;
          } else {
            this.onlyEstimateIsRejected = false;
          }
        }
       
        break;
    }
    
    return statusDisplay;
  }

  public setApprovalTask(
    type: '' | 'sg' | 'contractor'| 'ldp'|'w9' | 'bidinvoice' |'permitreceipt' | 'permit' | 'house' | 'crawlSpace' |'receipt'
  ): void {
    this.viewApprovalTask = type;
    this.taskLastFocus = type;
    if (type && this.steps) {
      const targetKey = Object.keys(this.steps).findIndex(x => x === type);
      Object.values(this.steps)[targetKey].helpTopic();
    }
  }

  public lookupOptions(name: string): IOptions[] {
    return this.listOptionSets.filter(i => i.name === name)[0].options;
  }

  /**********************************************
   * Help
   */
  public helpByTopic(topic: string) {
    return this.listHelp.filter(
      i => i.topicCodeOptionSet.toLowerCase() === topic.toLowerCase()
    );
  }

  public onClickShowHelp(item: IHelp): void {
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  /*******************************************
   * Add Permit File
   */
  public onPermitAddChange(event: any): void {
    if (event.value) {
      this.showAddAnother = false;
      this.addPermitFileEvent(event.value);
    }
  }

  public addPermitFileEvent(permitType: string): void {
    const dialogUploadDataItem: DialogUploadData = {} as DialogUploadData;
    dialogUploadDataItem.attachmentName = permitType;

    const dialogRef = this.dialogUpload.open(DialogUploadComponent, {
      width: '350px',
      data: dialogUploadDataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      let taskId: string;
      if (result && result.uploadFileName.length > 0) {
        this.progressSaveOptionalPermitDoc = true;
         const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
        blobToBase64String(result.uploadFile)
          .then(base64string => {
            const fileString64 = base64string;
            const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
            approvalTaskItem.typeCode = 700000000;
            approvalTaskItem.payloadTypeCode = 700000000;
            approvalTaskItem.statusCode = 700000003;
            approvalTaskItem.allowRecordCreation = true;
            approvalTaskItem.payloadName = fileName;
            taskId = this.taskBuildingPermit.id;
            approvalTaskItem.name = permitType;
            if (this.isContractor()) {
              approvalTaskItem.createdByType = 700000001;
            }
            if (this.isHomeowner()) {
              approvalTaskItem.createdByType = 700000000;
            }
            this.apiApprovalTaskItem
              .saveItem(approvalTaskItem, this.application.id, taskId)
              .subscribe(data => {
                const newItem =cloneDeep(data as IApprovalTaskItem);
                this.taskBuildingPermit.approvalTaskItems.push(newItem);

                const indexItem = this.taskBuildingPermit.approvalTaskItems.findIndex(
                  i => i.id === data.id
                );
                this.taskBuildingPermit.approvalTaskItems[
                  indexItem
                ] = data as IApprovalTaskItem;
                taskId = this.taskBuildingPermit.approvalTaskItems[indexItem]
                  .id;
                const annotationInput: IAnnotationInput = {
                  id: null,
                  _Objectid_Value: this.taskBuildingPermit.approvalTaskItems[
                    indexItem
                  ].id,
                  objectTypeCode: 'cea_approvaltaskitem',
                  fileName: fileName,
                  fileSize: result.uploadFile.size,
                  mimeType: result.uploadFile.type,
                  subject: fileName,
                  noteText: `${result.permitType}`,
                  documentBody: fileString64
                };

                this.apiAnnotation
                  .saveAnnotation(annotationInput)
                  .subscribe(_data => {
                   var data = cloneDeep(_data);
                    this.progressSaveOptionalPermitDoc = false;
                    const newPayload = data.id;
                    this.taskBuildingPermit.approvalTaskItems[
                      indexItem
                    ].payload = newPayload;
                    this.resetAddPermit();
                    this.emitFileChangeEvent.emit(this.taskBuildingPermit);
                    this.refreshData(false, null, null, null,null, null, null);
                  });
              });
          })
          .catch(err => {
            console.warn(`Unable to convert permit file`);
            this.resetAddPermit();
          });
      } else {
        this.resetAddPermit();
      }
    });
  }

  private resetAddPermit(): void {
    this.addPermitInfo.get('permitType').setValue(null);
    this.showAddAnother = true;
  }

  private updateBidAmountsOnApp(input: IApplicationInput) {
    if (input.contractorBidAmount1 !== undefined) {
      this.application.contractorBidAmount1 = input.contractorBidAmount1;
      if (input.contractorBidAmount1Selected !== undefined) {
        this.application.contractorBidAmount1Selected =
          input.contractorBidAmount1Selected;
      }
      if (input.contractorBidAmount2 !== undefined) {
        this.application.contractorBidAmount2 = input.contractorBidAmount2;
      }
      if (input.contractorBidReason !== undefined) {
        this.application.contractorBidReason = input.contractorBidReason;
      }
      this.checkIfReadyForSubmission(input.contractorBidAmount1, input.contractorBidAmount1Selected, input.contractorBidReason,input.ldpBidAmount1, input.ldpBidAmount1Selected, input.ldpBidReason);
    }
  }

  private updateEnggBidAmountsOnApp(input: IApplicationInput) {
    if (input.ldpBidAmount1 !== undefined) {
      this.application.ldpBidAmount1 = input.ldpBidAmount1;
      if (input.ldpBidAmount1Selected !== undefined) {
        this.application.ldpBidAmount1Selected =
          input.ldpBidAmount1Selected;
      }
      if (input.ldpBidAmount2 !== undefined) {
        this.application.ldpBidAmount2 = input.ldpBidAmount2;
      }
      if (input.ldpBidReason !== undefined) {
        this.application.ldpBidReason = input.ldpBidReason;
      }
      this.checkIfReadyForSubmission(input.contractorBidAmount1, input.contractorBidAmount1Selected, input.contractorBidReason,input.ldpBidAmount1, input.ldpBidAmount1Selected, input.ldpBidReason);
    }
  }

  /**********************************************
   * Help
   */
  private getHelpText(name: string): string {
    let message = '';
    const indexSGincomeassessment = this.listHelp.findIndex(
      i => i.name.toLowerCase() === name
    );
    if (indexSGincomeassessment >= 0)
      message = this.listHelp[indexSGincomeassessment].answer;

    return message;
  }

  public IsDisablebutton(): void {
    const sg4506cOnly = this.taskSG.approvalTaskItems.filter(
      x => x.payloadTypeCode === 700000002 && x.statusCode !== 700000002
    );
    const sg4506R4ejectedOnly = this.taskSG.approvalTaskItems.filter(
      x => x.payloadTypeCode === 700000002 && x.statusCode === 700000002
    );
    this.sg4506cCount = sg4506cOnly.length;
    this.sg4506cRejectedCount = sg4506R4ejectedOnly.length;
    if (this.sg4506cRejectedCount > 0) this.sg4506cRejected = true;

    if (this.application.envelopeOkToVerify) {
      this.disableSgSubmitButton = true;
    } else {
      if (
        (this.disableSgSubmitButton =
          this.sg4506cCount + this.sg4506cRejectedCount >= this.application.sGmaxrequests)
      ) {
        this.disableSgSubmitButton = true;
      } else {
        this.disableSgSubmitButton = false;
      }
    }
  }
  private isSgCheckBoxDisabled(statusCode: number): boolean {

    if(statusCode === 700000001){
      return false;
    }
    if(statusCode === 700000003){
      return false;
    }
    return true;
  }
  private CheckIsSG(): void {
    this.w9message = this.getHelpText('w9mainmessage');
    if (!this.application.envelopeOkToVerify) {
      this.incomeverificationsubmit = this.getHelpText(
        'sgsubmitincomeassessmentmsg'
      );
    }

    this.sgincomeverificationconfirmmessage = this.getHelpText(
      'sgincomeverificationconfirmmessage'
    );
    
    if (this.application.sGStatus > 0) {
      if (
        this.application.sGStatus === 700000001 ||
        this.application.sGStatus === 700000002 ||
        this.application.sGStatus === 700000003 ||
        this.application.sGStatus === 700000004
      ) {
        this.IsSGApplication = true;
        this.w9message = this.getHelpText('w9sgmessage');
        switch (this.application.sGStatus) {
          case 700000001:
            this.textSGMessage = this.getHelpText('sgwaitlist');
            this.isSgWaitList = true;
            this.canshowtask = false;
            this.sgheadingstatus = 'Waitlist';
            break;
          case 700000002:
            this.textSGMessage = this.getHelpText('sgincomeassessment');
            this.sgmax4506climtmsg = this.getHelpText('sgmax4506climtmsg');
            this.isSgWaitList = false;
            this.sgheadingstatus = 'Waiting for Information';
            this.IsDisablebutton();
            if (
              this.application.sGStatus === 700000002 &&
              this.taskSG.statusCode === 700000003 &&
              this.application.envelopeOkToVerify
            ) {
              this.sgheadingstatus = 'Under Review (In process)';
            }
            if (
              this.application.sGStatus === 700000002 &&
              this.application.envelopeOkToVerify &&
              this.taskSG.statusCode === 700000002
            ) {
              this.sgheadingstatus = 'Action required';
            }
            if (
              this.application.sGStatus === 700000002 &&
              this.application.envelopeOkToVerify &&
              this.taskSG.statusCode === 700000001
            ) {
              this.sgheadingstatus = 'Under Review (In process)';
            }

            this.canshowtask = false;
            break;
          case 700000003:
            this.textSGMessage = this.getHelpText('sgincomeassessment');
            this.isSgWaitList = false;
            this.canshowtask = true;
            this.sgheadingstatus = 'Not Qualified';
            this.sgnotqualifiedstatusmsg = this.getHelpText(
              'sgnotqualifiedmessage'
            );
            break;
          case 700000004:
            this.textSGMessage = this.getHelpText('sgincomeassessment');
            this.isSgWaitList = false;
            this.canshowtask = true;
            this.sgheadingstatus = 'Verified';
            this.sgqualifiedstatusmsg = this.getHelpText('sgqualifiedmessage');
            break;
        }
      }
    }

    //building permit text
    if (this.IsSGApplication) {
      this.textBuildingPermitMessage = this.getHelpText('sgbuildingpermitmsg');
    } else {
      this.textBuildingPermitMessage = this.getHelpText('buildingpermitmsg');
    }
    this.checkPermitReceiptNeedWork();
    this.checkBidNeedWork();
  }

    public onwithdrawSG(): void {
    this.emitWithDrawSGApplication.emit();
  }
  public onWithChangeEventTerms(event): void {
    this.withdrawagreeToTerms = event.checked;
  }
  public onSubmitChangeEventTerms(event): void {
    this.submitdrawagreeToTerms = event.checked;
    if (this.submitdrawagreeToTerms) {
      this.disableSgSubmitButton = true;
    } else {
      this.IsDisablebutton();
    }
  }
  public onEmitIVRUpdate(event) {
    this.emitIVRChangeEvent.emit(event);
  }
  public sgWaitList(): boolean {
    if (this.application.sGStatus === null) {
      return false;
    }
    if (this.application.sGStatus === 700000001) {
      return true;
    }

    return false;
  }

  public onClickReSubmitDocumentsTaxRequestData(item: IApprovalTaskItem){
    this.disableSgSubmitButton = true;
 this.formAutoSave = true;
   var taxrequestlimitmsg= this.getHelpText(
      'sgtaxrequestconfirmationmessage'
    );
   var taxrequestlimitmsg = this.getHelpText('sgmax4506climtmsg');
    var isBorrowerAssisted = false;

   const receipt1 = item.recipients.find(r => r.primary === true);
   const receipt2 = item.recipients.find(r => r.primary !== true);

 let signer1: SignerInput = {} as SignerInput;
     
      signer1.signerNameFirst= receipt1?.nameFirst || '',
     signer1.signerNameMiddle= receipt1?.nameMiddle || '',
     signer1.signerNameLast=receipt1?.nameLast || ''
   
 let signer2: SignerInput = {} as SignerInput;
     
      signer2.signerNameFirst= receipt2?.nameFirst || '',
     signer2.signerNameMiddle= receipt2?.nameMiddle || '',
     signer2.signerNameLast=receipt2?.nameLast || ''
    var envelopeId: string = null; 
     if (this.application.envelopeId) {
      envelopeId = this.application.envelopeId;
    } 
 var documentId: string = null; 
    const events = [];
        var returnUrl = window.location.host;
        events.push(
          this.createTaxRequestForms(
             this.application.id,
            this.application._Ebb_DwellingId,
            this.application.sGStatus,
            this.taskSG.id,
            item.id,
            signer1,
            signer2,
            this.applicationOwner.emailAddress1,
            envelopeId,
            documentId,
            item.attempt,
            returnUrl,
            isBorrowerAssisted
          )
        );

  this.createTaxRequestFormsAction(events, taxrequestlimitmsg,isBorrowerAssisted);

  }
  /**********************************************
   * Tax Request Data
   */
   public onClickSubmitTaxRequestData(checkcount:boolean,isBorrowerAssisted:boolean,approvalTaskItemKey:string): void {
    if (this.application.sGmaxrequests <= this.sg4506cCount && checkcount) {
      this.onTaxRequestAlertMessage(this.getHelpText('sgmax4506climtmsg'));
      return;
    }
    if(isBorrowerAssisted === undefined){
      isBorrowerAssisted= this.application.sg4506CRequestType === 700000001? true:false
    }
    this.disableSgSubmitButton = true;
    const dataDialog: IApplicationTaxRequest = {} as IApplicationTaxRequest;
    dataDialog.applicationId = this.application.id;
    dataDialog.approvalTaskId = this.taskSG.id;
    dataDialog.email = this.applicationOwner.emailAddress1;
    dataDialog.dwellingId = this.application._Ebb_DwellingId;
    dataDialog.taxrequestmsg = this.getHelpText('sgtaxrequestmessage');
    dataDialog.taxrequestconfirmmsg = this.getHelpText(
      'sgtaxrequestconfirmationmessage'
    );
    dataDialog.taxrequestlimitmsg = this.getHelpText('sgmax4506climtmsg');
    dataDialog.documentId = null;

    if (this.application.envelopeId) {
      dataDialog.envelopeId = this.application.envelopeId;
    } else {
      dataDialog.envelopeId = null;
    }
    dataDialog.taxYear ='';
    if (approvalTaskItemKey !== '') {
      dataDialog.approvalTaskItemKey = approvalTaskItemKey;
      dataDialog.taxYear=this.taxYear;
      
    }
    dataDialog.attempt = this.attempt;
    dataDialog.isBorrowerAssisted = isBorrowerAssisted;
    const dialogRef = this.dialogTaxRequest.open(
      DialogtaxrequestformComponent,
      {
        maxWidth: '95vw',
        maxHeight: '85vh',
        height: '650px',
        width: '450px',
        data: dataDialog
      }
    );

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.formAutoSave = true;
        const events = [];
        var returnUrl = window.location.host;
        events.push(
          this.createTaxRequestForms(
            dataDialog.applicationId,
            this.application._Ebb_DwellingId,
            this.application.sGStatus,
            dataDialog.approvalTaskId,
            dataDialog.approvalTaskItemKey,
            dataDialog.signer1,
            dataDialog.signer2,
            dataDialog.email,
            dataDialog.envelopeId,
            dataDialog.documentId,
            dataDialog.attempt,
            returnUrl,
            isBorrowerAssisted
          )
        );

        this.createTaxRequestFormsAction(events, dataDialog.taxrequestlimitmsg,isBorrowerAssisted);
      } else {
        this.IsDisablebutton();
      }
    });
  }

  private createTaxRequestFormsAction(events: any[], taxrequestlimitmsg: string,isBorrowerAssisted): void {
    forkJoin(events)
      .pipe(defaultIfEmpty(null))
      .subscribe(
        (responses: any[]) => {
          this.formAutoSave = false;
          if (isBorrowerAssisted) {
            const response = responses?.[0];
            // Check if response was successful
            if (response?.success == true) {
              this.onBAConfirmMessage();
            } else {
              this.onTaxRequestAlertMessage('We were not able to complete your request, please try in one minute. If you continue to receive this message please contact us.');
            }



          } else {
            this.onConfirmMessage();
          }
        },
        error => {
          this.formAutoSave = false;
          if (error
            .toString()
            .toLowerCase()
            .indexOf('limit reached') >= 0) {
            this.onTaxRequestAlertMessage(taxrequestlimitmsg);
          } else if (error
            .toString()
            .toLowerCase()
            .indexOf('failed to acquire the lock') >= 0) {
            //docusign lock error
            this.onTaxRequestAlertMessage('We were not able to complete your request, please try in one minute. If you continue to receive this message please contact us.');
          } else {
            // else catch
            this.onTaxRequestAlertMessage('We were not able to complete your request, please try in one minute. If you continue to receive this message please contact us.');
          }
          console.warn(`ERROR: onClickSubmitTaxRequestData() - ${error}`);
        }
      );
  }

  private createTaxRequestForms(
    applicationId: string,
    dwellingId: string,
    applicationSgStatus: number,
    approvalTaskId: string,
    approvalTaskItemKey: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    attempt: number, returnUrl:string, isBorrowerAssisted: boolean
  ): Observable<any> {
    return this.apiTaxRequest
      .createTaxRequestForms(
        applicationId,
        dwellingId,
        applicationSgStatus,
        approvalTaskId,
        approvalTaskItemKey,
        signer1,
        signer2,
        email,
        envelopeId,
        documentId,
        attempt,returnUrl,isBorrowerAssisted
      )
      .pipe(
        map(result => {
          if (!result) {
            console.log('error createTaxRequestForms');
          } else {
            console.log('createTaxRequestForms');
          }
          return result;
        })
      );
  }

  public getsgsubmitmessage(msg: string) {
    return this.getHelpText(msg);
  }

  public onClickTaxIncomeSubmit() {
    this.formAutoSave = true;
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    applicationInput.envelopeOkToVerify = true;
    applicationInput.sGSubmittedDate = new Date();
    const events = [];
    events.push(
      this.apiApplication.updateApplication(
        applicationInput,
        this.application.id
      )
    );
    forkJoin(events)
      .pipe(defaultIfEmpty(null))
      .subscribe(
        () => {
          this.formAutoSave = false;
          this.onEmitDataFormUpdate(this.taskSG);
        },
        error =>
          console.warn(`ERROR: onChangeEventContractorSwitch() - ${error}`)
      );
  }

  private start(): void {
    localStorage.setItem('refresh', 'false');
    window.addEventListener('storage', this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea === localStorage) {
      let v;
      try {
        if (event.key === 'refresh') {
          v = JSON.parse(event.newValue);

          if (v) {
            localStorage.setItem('refresh', 'false');
            this.onEmitDataFormUpdate(this.taskSG);
          }
        }
      } catch (e) {
        v = event.newValue;
      }
      this.onSubject.next({ key: event.key, value: v });
    }
  }

  public clear(key) {
    localStorage.removeItem(key);
    this.onSubject.next({ key: key, value: null });
  }

  private stop(): void {
    window.removeEventListener('storage', this.storageEventListener.bind(this));
    this.onSubject.complete();
  }

  public onConfirmMessage(): void {
    const dialogViewDataItem = {
      message: this.sgincomeverificationconfirmmessage,
      buttonlabel: 'OK'
    };
    const dialogRefConfirm = this.dialogConfirmSubmit.open(
      DialogConfirmMessageComponent,
      { width: '400px', data: dialogViewDataItem }
    );
    dialogRefConfirm.afterClosed().subscribe(result => {
      this.onEmitDataFormUpdate(this.taskSG);
    });
  }
  public onBAConfirmMessage(): void {
    const irsmsg = this.listHelp.find(x => x.name.toLowerCase() === 'irsactionrequired');
    const dialogViewDataItem = {
      title: irsmsg.question,
      message: irsmsg.answer,
      buttonlabel: 'OK'
    };
    const dialogRefConfirm = this.dialogConfirmSubmit.open(
      DialogConfirmMessageComponent,
      { width: '400px', data: dialogViewDataItem }
    );
    dialogRefConfirm.afterClosed().subscribe(result => {
      this.onEmitDataFormUpdate(this.taskSG);
    });
  }
  public onTaxRequestAlertMessage(msg: string): void {
    const dialogViewDataItem = {
      message: msg,
      buttonlabel: 'OK'
    };
    const dialogRefLimit = this.dialogConfirmSubmit.open(
      DialogConfirmMessageComponent,
      { width: '400px', data: dialogViewDataItem }
    );
    dialogRefLimit.afterClosed().subscribe(result => {
      this.onEmitDataFormUpdate(this.taskSG);
      this.ngOnInit();
    });
  }

  public completeW9Message(msg: string): void {
    const dialogViewDataItem = {
      message: msg,
      buttonlabel: 'OK'
    };
    const dialogW9Msg = this.dialogConfirmSubmit.open(
      DialogConfirmMessageComponent,
      { width: '400px', data: dialogViewDataItem }
    );
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

  onEmitBidInvoiceChoiceEvent($event: boolean) {
    this.emitBidInvoiceInitEvent.emit($event);
  }
  onEmitPermitReceiptChoiceEvent($event: boolean) {
    this.emitBidInvoiceInitEvent.emit($event);
  }
}
